import Cookies from "js-cookie";
import Moment from 'moment/min/moment-with-locales.min';

export const DEFAULT_LANGUAGE_COOKIE_NAME = 'easybizy-default-locale';

export const getLangCookie = () => {
	return Cookies.get(DEFAULT_LANGUAGE_COOKIE_NAME);
}

export const setLanguageInCookieIfNeeded = (lang, force) => {
	const isHebrew = lang === 'he-IL';
	Moment.locale(isHebrew ? 'he' : 'en');
	let pref = {
		expires: 365,
		domain: getDomainWithoutSubdomain()
	};

	if (force) {
		Cookies.set(DEFAULT_LANGUAGE_COOKIE_NAME, lang, pref);
	}
}


const getDomainWithoutSubdomain = () => {
	const urlParts = document.location.hostname.split('.')

	let toReturn = urlParts
		.slice(0)
		.slice(-(urlParts.length === 4 ? 3 : 2))
		.join('.')

	if (toReturn !== 'localhost') {
		toReturn = '.' + toReturn;
	} else {
		toReturn = undefined;
	}

	return toReturn;
}
